<div class="card custom__card" [style.border-color]="borderColor">
  <div [ngClass]="{ 'p-20': internalPadding }">
    <ng-content></ng-content>
  </div>
</div>
